import {SpaceProto} from "../space-proto";
import ProjectSession from "../../project/project-session";
import Navigation_ButtonGeneric from "../../../../layout/navigation/buttons/generic";
import {
    NavigationButtonPosition,
    NavigationSectionConfig,
    NavigationSectionType,
} from "../../navigation/@const";
import MainMenu_Workspace from "../../../../layout/menu/sections/workspace/workspace";
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click";
import mainMenu_workspaceViews from "../../../../layout/menu/actions/workspace-views";
import Pin from "../../pin/pin";
import {PinLocationTypes} from "../../pin/@types";
import NavigationMenuSearch from "../../../../layout/search/sections/navigation-menu/navigation-menu-search";
import {GroupedData} from "../../../data-structures/group";

export default class Workspace extends SpaceProto {

    public readonly project     : ProjectSession

    constructor(project:ProjectSession) {
        super('workspace-'+project.id)

        this.project                = project

        this.updateTitleAndIcon()

        this.canHaveProjects        = true

    }

    get isWorkspace(): boolean {
        return true
    }

    get enabled(): boolean {
        return this.project.hasAccess
    }

    get inNavigationPanel(): boolean {
        if (this.project.isArchived) {
            return false
        }

        return super.inNavigationPanel
    }

    get navigationStructureConfig():NavigationSectionConfig {


        const navigationPosition : NavigationButtonPosition = (gd.user.settings.navigation.buttonPositions[this.id]===NavigationButtonPosition.MORE)?NavigationButtonPosition.MORE:NavigationButtonPosition.TOP

        return {
            id              : this.id,
            workspace       : this.project,
            icon            : this.project.iconClass,
            hint            : this.project.name,
            renderComponent : Navigation_ButtonGeneric,
            type            : NavigationSectionType.WORKSPACE,
            menuComponent   : MainMenu_Workspace,
            onClick         : navigationStructureOnClick,

            position        : navigationPosition,
        }
    }

    get rootTags():ProjectSession[] {

        const rootTags : ProjectSession[] = _.filter(this.project.treeChildren, (project:ProjectSession)=> {

            return project.isTag && !project.isDeleted
        })

        return rootTags

    }

    get rootProjects():ProjectSession[] {
        /*const projects : ProjectSession[] = _.filter(this.project.treeChildren, (project:ProjectSession)=> {
            return !project.isTag && !project.isView && !project.isDeleted && (project.hasAccess || project.hasAccessibleChildren)
        })*/

        const projects : ProjectSession[] = []

        // look for first accessible project down the tree for each treeChildren and add it as root project
        const recursiveLookForRootProjects = (projectSession: ProjectSession) => {
            _.map(projectSession.treeChildren, (project:ProjectSession)=> {
                // add as root project if it is not tag, view or is deleted and user has access to it or option showParentsDespiteAccess is enabled
                if (!project.isTag && !project.isView && !project.isDeleted && (gd.company.settings.projectAccess.showParentsDespiteAccess || project.hasAccess)) {
                    projects.push(project)
                } else {
                    recursiveLookForRootProjects(project)
                }
            })
        }

        recursiveLookForRootProjects(this.project)

        return projects
    }

    get menuResourcesCounter() {
        // make sure we do not show root projects which are starred
        const starredProjects : ID[] = gd.session.starredItems.getProjectsIds() || []
        const workspaceRootProjects = _.filter(this.rootProjects, (project:ProjectSession)=>{
            return !starredProjects.includes(project.id)
        })
        return workspaceRootProjects.length
    }

    async search(keyword: string): Promise<GroupedData> {

        const workspaceViews = mainMenu_workspaceViews(this.project)

        const wsViews: ProjectSession[] = []

        _.map(workspaceViews, (projectId:ID) => {
            const project: ProjectSession | null = gd.session.projects.get(projectId)
            if(project) wsViews.push(project)
        })

        let pinnedItems = _.filter(gd.session.pins.models, (pin: Pin)=>{

            if (pin.companyId !== gd.companyId) return false
            if (pin.location.type !== PinLocationTypes.WORKSPACE || pin.location.value !== this.project.id) return false

            return !!pin.task || !!pin.document || !!pin.user || !!pin.project
        });

        return await new NavigationMenuSearch(keyword, this).search([this.project.id], pinnedItems, wsViews)
    }

    updateTitleAndIcon() {
        this.title  = this.project.name
        this.icon   = this.project.iconClass
    }
}
